function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconQrCodeRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 28h4v2H2v-6h2v4zm26 2h-6v-2h4v-4h2v6zM12 18h4v-2h4v4h-2v-2h-2v2h-2v4H8v-6h2v-2h2v2zm6 6h-2v-2h2v2zm6-2h-2v2h-2v-4h4v2zm-14 0h2v-2h-2v2zm14-4h-2v-4h-4V8h6v10zm-8-4v2h-2v-2h2zm-2-4h2v2h-2v2H8V8h6v2zm-4 2h2v-2h-2v2zm10 0h2v-2h-2v2zM8 4H4v4H2V2h6v2zm22 4h-2V4h-4V2h6v6z",
    fill: props.color
  }));
}

export default SvgIconQrCodeRexOutline;